<div class="modal-content" id="delete_modal_folder_position">
  <div class="modal-body modal-padding">
    <h5>Confirm Delete</h5>
    <p>Are you sure you want to delete this DEM file?</p>
    <div class="button-wrapper">
      <button (click)="deleteFile()" class="modal-button-style" id="rename_button" data-dismiss="modal" viewid="721"
        viewindex="0">
        Yes
      </button>
      <button class="modal-button-style" data-dismiss="modal" (click)="close()">Cancel</button>
    </div>
  </div>
</div>
